import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

import { UpdateShareGroupsObject } from './ShareGroups';

interface Props {
  groupId: number;
  updateGroups: (updateObject: UpdateShareGroupsObject) => Promise<void>;
}

const ShareGroupsRemove = ({ groupId, updateGroups }: Props) => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const removeGroup = async () => {
    await api.delete(`/admin/groups/${groupId}/courses/${course.id}`);
    await updateGroups({ showLoading: false });
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.commonRemoveGroup}
      category="danger"
      confirmText={messages.settingsGroupsRemoveConfirm}
      confirmTitle={messages.commonRemoveGroup}
      onConfirm={removeGroup}
      successMessage={messages.commonRemoveGroupSuccess}
    />
  );
};

export default ShareGroupsRemove;
